<template>
  <div class="d-flex align-center gap-2 flex-wrap" data-testid="gl-action-toolbar">
    <!-- Grouped/Ungrouped View Toggle - Only for SL Breakup (separate from Commentary/List view toggle) -->
    <div class="toggle-slider-container" v-if="showViewToggle" data-testid="gl-action-toolbar__view-toggle-container">
      <div class="toggle-slider-bg"></div>
      <div class="toggle-slider-indicator" :class="{ 'slide-right': internalSlGroupedView === 1 }"></div>
      <div class="toggle-slider-buttons">
        <button 
          class="toggle-slider-btn" 
          :class="{ 'active': internalSlGroupedView === 0 }" 
          @click="internalSlGroupedView = 0"
          data-testid="gl-action-toolbar__group-toggle-btn"
        >
          Grouped
        </button>
        <button 
          class="toggle-slider-btn" 
          :class="{ 'active': internalSlGroupedView === 1 }" 
          @click="internalSlGroupedView = 1"
          data-testid="gl-action-toolbar__ungroup-toggle-btn"
        >
          Ungrouped
        </button>
      </div>
    </div>

    <!-- Status Chip: Closed/Open -->
    <!-- <div class="" v-if="toggleview !== 3 && !hideExtraControls && !isRevenueBreakupMode" @click="$emit('open-workflows-dialog')">
      <v-chip 
        label 
        color="success" 
        class="pl-2 cursor-pointer"
        v-if="isRuClosed"
        data-testid="gl-action-toolbar__status-chip-closed"
      >
        Closed
      </v-chip>
      <v-chip label color="info" v-else class="cursor-pointer" data-testid="gl-action-toolbar__status-chip-open">
        <span>Open</span>
      </v-chip>
    </div> -->

    <!-- Role Display: Chip-based (when SOD enabled or single role) -->
    <div class="" v-if="!hideRoleSelector && (isSodEnabled || ruRoleOptions.length <= 1) && !hideExtraControls && !isRevenueBreakupMode">
      
      <div class="role-chip cursor-pointer" v-if="ispreparer">
        <img src="/img/icons/User.svg" class="role-chip__icon" alt="User Icon">
        <span class="role-chip__label">{{ $nova.labelsName('cycle_page', 'commentary_local_preparer_label', 'Local Preparer') }}</span>
      </div>
      <div class="role-chip cursor-pointer" v-else-if="isapprover">
        <img src="/img/icons/User.svg" class="role-chip__icon" alt="User Icon">
        <span class="role-chip__label">{{ $nova.labelsName('cycle_page', 'commentary_local_approver_label', 'Local Approver') }}</span>
      </div>
      <div 
        class="role-chip cursor-pointer"
        v-else-if="isregionalapprover || toggleview === 3"
        data-testid="gl-action-toolbar__role-regional-approver"
      >
        <img src="/img/icons/User.svg" class="role-chip__icon" alt="User Icon">
        <span class="role-chip__label">{{ $nova.labelsName('cycle_page', 'commentary_regional_approver_label', 'Regional Approver') }}</span>
      </div>
      <div class="role-chip cursor-pointer" v-else-if="ismanager">
        <img src="/img/icons/User.svg" class="role-chip__icon" alt="User Icon">
        <span class="role-chip__label">Manager</span>
      </div>
      <div class="role-chip cursor-pointer" v-else-if="isviewonly">
        <img src="/img/icons/User.svg" class="role-chip__icon" alt="User Icon">
        <span class="role-chip__label">View Only</span>
      </div>
    </div>

    <!-- Role Selector: Dropdown (when SOD disabled and multiple roles) -->
    <div v-else-if="!hideRoleSelector && !hideExtraControls && !isRevenueBreakupMode" class="role-selector__wrapper">
      <v-menu
        v-model="roleSelectorMenuOpen"
        left
        offset-y
        transition="slide-y-transition"
        data-testid="gl-action-toolbar__role-selector-menu"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="role-selector__activator cursor-pointer"
            v-bind="attrs"
            v-on="on"
            data-testid="gl-action-toolbar__role-selector"
          >
            <div class="role-chip__content">
              <!-- <v-icon small class="role-chip__icon">mdi-account</v-icon> -->
              <img src="/img/icons/User.svg" alt="User Icon">
              <span class="role-chip__label font-weight-semibold">{{ roleSelectorLabel }}</span>
            </div>
            <img src="/img/icons/downArrow.svg" alt="down arrow" class="role-selector__chevron">
          </div>
        </template>
        <v-card class="role-selector__menu">
          <v-list class="pa-0 d-flex flex-column gap-1" data-testid="gl-action-toolbar__role-options-list">
            <v-list-item
              v-for="option in ruRoleOptions"
              :key="option.value"
              @click="handleRoleSelect(option.value)"
              class="role-selector__item"
              :class="{ 'role-selector__item--active': option.value === selectedRuRole }"
              data-testid="gl-action-toolbar__role-option"
            >
              <div class="role-chip__content">
                <!-- <v-icon small class="role-chip__icon">mdi-account</v-icon> -->
                <span class="role-chip__label">{{ option.label }}</span>
              </div>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>

   
    <!-- View Options Dropdown -->
    <v-menu
      v-if="!hideExtraControls && !isRevenueBreakupMode"
      v-model="viewOptionsMenuOpen"
      offset-y
      left
      transition="slide-y-transition"
      :close-on-content-click="false"
      data-testid="gl-action-toolbar__view-options-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="view-options-chip cursor-pointer"
          data-testid="gl-action-toolbar__view-options-btn"
        >
          <img src="/img/icons/ViewOption.svg" alt="View Options" class="view-options-chip__icon" />
          <span class="view-options-chip__label">{{ viewOptionsLabel }} </span>
          <img class="view-options-chip__chevron" src="/img/icons/downArrow.svg" alt="down arrow" />
        </div>
      </template>
      <v-card class="view-options-card" data-testid="gl-action-toolbar__view-options-card">
        <!-- View Toggle Section -->
        <div class="view-options-section">
          <div class="view-options-section__header">View Option</div>
          <div class="view-options-section__content">
            <v-radio-group
              :value="isCommentaryView"
              @change="handleViewToggle($event)"
              hide-details
              dense
              class="ma-0 pa-0 view-options-radio-group"
            >
              <v-radio
                :value="false"
                color="primary"
                class="view-options-radio ma-0 pa-0"
                data-testid="gl-action-toolbar__list-view-radio"
              >
                <template v-slot:label>
                  <span class="view-options-radio__label">List Options</span>
                </template>
              </v-radio>
              <v-radio
                :value="true"
                color="primary"
                class="view-options-radio ma-0 pa-0"
                data-testid="gl-action-toolbar__commentary-view-radio"
              >
                <template v-slot:label>
                  <span class="view-options-radio__label">Commentary Options</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </div>

        <v-divider class="my-2"></v-divider>

        <!-- Read Toggle Section - "All" option available for both views -->
        <div class="view-options-section">
          <div class="view-options-section__header">Read Options</div>
          <div class="view-options-section__content">
            <v-radio-group
              :value="cycletypeReadview"
              @change="handleReadToggle($event)"
              hide-details
              dense
              class="ma-0 pa-0 view-options-radio-group"
            >
              <!-- All option - Available for both List View and Commentary View -->
              <v-radio
                value="All"
                color="primary"
                class="view-options-radio ma-0 pa-0"
                data-testid="gl-action-toolbar__all-radio"
              >
                <template v-slot:label>
                  <span class="view-options-radio__label">All</span>
                </template>
              </v-radio>
              <v-radio
                value="Proforma"
                color="primary"
                class="view-options-radio ma-0 pa-0"
                data-testid="gl-action-toolbar__vs-proforma-radio"
              >
                <template v-slot:label>
                  <span class="view-options-radio__label">vs {{ proformaLabel }}</span>
                </template>
              </v-radio>
              <v-radio
                value="Forecast"
                color="primary"
                class="view-options-radio ma-0 pa-0"
                data-testid="gl-action-toolbar__vs-forecast-radio"
              >
                <template v-slot:label>
                  <span class="view-options-radio__label">vs {{ forecastLabel }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-card>
    </v-menu>

    <!-- Custom View Toggle - Hidden for Revenue Breakup and SL Breakup -->
    <div 
      v-if="!hideExtraControls && !isRevenueBreakupMode && !showViewToggle"
      class="custom-view-box cursor-pointer"
      :class="{ 'custom-view-box--active': customfilterstoggle }"
      @click="$emit('update:custom-filters-toggle', !customfilterstoggle)"
      data-testid="gl-action-toolbar__custom-view-toggle"
    >
      <img src="/img/icons/CustomView.svg" class="custom-view-box__icon"
        :class="{ 'custom-view-box__icon--active': customfilterstoggle }" alt="">
    </div>

    <v-spacer></v-spacer>




    <!-- Comparison Selector -->
    <!-- <span class="" v-if="toggletableview === 1 && !hideExtraControls && !isRevenueBreakupMode">
      <v-select 
        dense 
        
        hide-details 
        :items="cycletypeItem" 
        label="Comparison" 
        solo 
        item-text="text"
        item-value="value" 
        :value="cycletypeReadview"
        @input="$emit('update:cycletype-readview', $event)"
        class="Comparion-select"
        :menu-props="{ contentClass: 'comparison-dropdown-menu' }"
        data-testid="gl-action-toolbar__comparison-selector"
      ></v-select>
    </span> -->

    <v-spacer></v-spacer>

    <!-- Import Commentary Button - Hidden for SL Breakup page (showViewToggle) -->
    <v-tooltip 
      left 
      content-class="tooltip-left"
      v-if="ispreparer && (ispendinglocalruapproval || ispendingregionalruapproval) && !hideExtraControls && !isRevenueBreakupMode && !showViewToggle"
    >
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          icon-style
          class=""
          name="import-commentary"
          @click="$emit('get-previous-cycle-list')"
          data-testid="gl-action-toolbar__import-commentary-btn"
          image="/img/icons/import-commentary.svg"
          image-width="32"
          image-alt="Import Commentary from previous period"
        />
      </template>
      <span v-if="workflows.islocalenabled">Import commentary from previous period</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <!-- Bulk Actions (when multiple items selected) -->
    <div class="d-flex align-center" v-if="(multiselectdata || []).length > 1 && !hideExtraControls" data-testid="gl-action-toolbar__bulk-actions">
      <!-- Request Commentary -->
      <v-tooltip 
        left 
        content-class="tooltip-left"
        v-if="((isapprover && (ispendinglocalruapproval || !workflows.isregionalenabled)) || isregionalapprover) && !isRevenueBreakupMode && hasRequestableItems"
      >
        <template v-slot:activator="{ on, attrs }">
          <base-button
            v-bind="attrs"
            v-on="on"
            icon-style
            class=""
            name="bulk-request-commentary"
            @click="$emit('perform-bulk-task', {}, 'request')"
            data-testid="gl-action-toolbar__bulk-request-btn"
            image="/img/icons/request-commentary.svg"
            image-width="32"
            image-alt="Request Commentary"
          />
        </template>
        <span v-if="(isapprover && workflows.islocalenabled) || (isregionalapprover && workflows.isregionalenabled)">
          Request Commentary for Selected
        </span>
        <span v-else>
          <span v-if="isapprover">{{ commentary_local_key_label }}</span>
          <span v-else>{{ commentary_regional_key_label }}</span>
          {{ workflowsDisabledMessage }}
        </span>
      </v-tooltip>

     

      <!-- Add Commentary to Selected -->
      <v-tooltip left content-class="tooltip-left" v-if="ispreparer">
        <template v-slot:activator="{ on, attrs }">
          <base-button
            v-bind="attrs"
            v-on="on"
            icon-style
            name="bulk-add-commentary"
            @click="$emit('perform-bulk-task', {}, 'addlocal')"
            data-testid="gl-action-toolbar__bulk-add-local-btn"
            image="/img/icons/multi-select-commentary.svg"
            image-width="32"
            image-alt="Add Commentary to Selected"
          />
        </template>
        <span v-if="ispreparer && !workflows.islocalenabled ">
          {{ commentary_local_key_label }} {{ workflowsDisabledMessage }}
        </span>
        <span v-else>
          Add Commentary to Selected
        </span>
      </v-tooltip>

      <!-- Generate AI Commentary for Selected -->
      <v-tooltip left content-class="tooltip-left" v-if="ispreparer">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            name="bulk-generate-ai"
            @click="$emit('perform-bulk-task', {}, 'generateai')"
            data-testid="gl-action-toolbar__bulk-generate-ai-btn"
          >
            <v-icon>mdi-robot</v-icon>
          </v-btn>
        </template>
        <span>Generate AI Commentary for Selected</span>
      </v-tooltip>

      <!-- Local Approve/Reject - Hidden in SL context (apiBasePath === 'sl_analysis') -->
      <v-tooltip left content-class="tooltip-left" v-if="isapprover && !isRevenueBreakupMode && slEnabled && apiBasePath !== 'sl_analysis'">
        <template v-slot:activator="{ on, attrs }">
          <base-button
            v-bind="attrs"
            v-on="on"
            icon-style
            class=""
            name="bulk-approve-reject"
            @click="$emit('perform-bulk-task', {}, 'approvelocal')" 
            color=""
            data-testid="gl-action-toolbar__bulk-approve-local-btn"
            image="/img/icons/multiselect-approve-commentary.svg"
            image-width="32"
            :image-alt="commentary_local_key_label + ' Approve/Reject all Selected'"
          />
        </template>
        <span v-if="workflows.islocalenabled">{{ commentary_local_key_label + ' Approve/Reject all Selected' }}</span>
        <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
      </v-tooltip>

      <!-- Regional Approve/Reject - Hidden in SL context (apiBasePath === 'sl_analysis') -->
      <v-tooltip left content-class="tooltip-left" v-if="isregionalapprover && cyclestage === 0 && !isRevenueBreakupMode && slEnabled && apiBasePath !== 'sl_analysis'">
        <template v-slot:activator="{ on, attrs }">
          <base-button
            v-bind="attrs"
            v-on="on"
            icon-style
            class=""
            name="bulk-approve-reject"
            @click="$emit('perform-bulk-task', {}, 'approveregional')"
            color=""
            data-testid="gl-action-toolbar__bulk-approve-regional-btn"
            image="/img/icons/multiselect-approve-commentary.svg"
            image-width="32"
            :image-alt="commentary_local_key_label + ' Approve/Reject all Selected'"
          />
        </template>
        <span v-if="workflows.isregionalenabled">{{ commentary_regional_key_label + ' Approve/Reject all Selected' }}</span>
        <span v-else>{{ 'Regional ' + workflowsDisabledMessage }}</span>
      </v-tooltip>
    </div>

    <!-- Bulk Upload Commentary (Preparer) - Hidden when all items are in regional stages -->
    <v-tooltip v-if="ispreparer && !hideExtraControls && hasPreparerActionableItems" left content-class="tooltip-left">
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          icon-style
          class=""
          name="bulk-commentary-file-upload"
          @click="$emit('open-bulk-commentary-dialog-local')"
          data-testid="gl-action-toolbar__bulk-upload-preparer-btn"
          image="/img/icons/bulk-submit-commentary.svg"
          image-width="32"
          image-alt="Bulk Submit Commentary"
        />
      </template>
      <span v-if="workflows.islocalenabled">Bulk Submit Commentary</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <!-- Bulk Upload Commentary (Approver) - Shown for both GL and SL contexts -->
    <v-tooltip v-if="isapprover && !hideExtraControls" left content-class="tooltip-left">
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          icon-style
          class=""
          name="bulk-commentary-file-upload"
          @click="$emit('open-bulk-commentary-dialog-approver')"
          data-testid="gl-action-toolbar__bulk-upload-approver-btn"
          image="/img/icons/bulk-submit-commentary.svg"
          image-width="32"
          image-alt="Bulk Approve Commentary"
        />
      </template>
      <span v-if="workflows.islocalenabled">Bulk Upload Commentary</span>
      <span v-else>{{ commentary_local_key_label }} {{ workflowsDisabledMessage }}</span>
    </v-tooltip>

    <!-- Bulk Approve/Reject Upload - Hidden in SL context (apiBasePath === 'sl_analysis') -->
    <v-tooltip 
      v-if="(isapprover || isregionalapprover) && toggleview !== 3 && toggletableview !== 1 && !hideExtraControls && !isRevenueBreakupMode && slEnabled && apiBasePath !== 'sl_analysis'" 
      left
      content-class="tooltip-left"
    >
      <template v-slot:activator="{ on, attrs }">
        <base-button
          v-bind="attrs"
          v-on="on"
          icon-style
          class=""
          name="bulk-commentary-file-upload"
          @click="$emit('open-bulk-approve-dialog')"
          data-testid="gl-action-toolbar__bulk-approve-upload-btn"
          image="/img/icons/approve-commentary.svg"
          image-width="20"
          image-alt="Bulk Approve Commentary"
        />
      </template>
      <span v-if="(isapprover && workflows.islocalenabled) || (isregionalapprover && workflows.isregionalenabled)">
        Bulk Approve/Reject Local Commentary
      </span>
      <span v-else>
        <span v-if="isapprover">{{ commentary_local_key_label }}</span>
        <span v-else>{{ commentary_regional_key_label }}</span>
        {{ workflowsDisabledMessage }}
      </span>
    </v-tooltip>


  
    <!-- Pagination -->
    <!-- <div class="radius-small border-on" v-if="toggleview === 3 && pagecount > 1 && !hideExtraControls">
      <v-btn icon :disabled="page === 1" @click="$emit('update:page', page - 1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="mx-1">Page {{ page }} of {{ pagecount }}</span>
      <v-btn icon :disabled="page === pagecount" @click="$emit('update:page', page + 1)" data-testid="gl-action-toolbar__pagination-next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div> -->
  </div>
</template>

<script>
import { REQUEST_COMMENTARY_ELIGIBLE_STAGES } from '../utils/constants';

export default {
  name: 'GLActionToolbar',
  props: {
    commentarydata: { type: Array, default: () => [] },
    toggleview: { type: Number, default: 0 },
    commentarycycledata: { type: Object, default: () => ({}) },
    workflows: { type: Object, default: () => ({ islocalenabled: true, isregionalenabled: true }) },
    isSodEnabled: { type: Boolean, default: false },
    slEnabled: { type: Boolean, default: true },
    ruRoleOptions: { type: Array, default: () => [] },
    isregionalapprover: { type: Boolean, default: false },
    ispreparer: { type: Boolean, default: false },
    isapprover: { type: Boolean, default: false },
    ismanager: { type: Boolean, default: false },
    isviewonly: { type: Boolean, default: false },
    selectedRuRole: { type: [String, Number, null], default: null },
    alluserassigned: { type: Boolean, default: true },
    commentary_local_key_label: { type: String, default: 'Local' },
    commentary_regional_key_label: { type: String, default: 'Regional' },
    selectedfilter: { type: Array, default: () => [] },
    customfilterstoggle: { type: Boolean, default: false },
    isCommentaryView: { type: Boolean, default: false },
    toggletableview: { type: Number, default: 0 },
    cycletypeItem: { type: Array, default: () => [] },
    cycletypeReadview: { type: String, default: 'Proforma' },
    ispendinglocalruapproval: { type: Boolean, default: false },
    ispendingregionalruapproval: { type: Boolean, default: false },
    workflowsDisabledMessage: { type: String, default: 'workflow disabled' },
    multiselectdata: { type: Array, default: () => [] },
    cyclestage: { type: Number, default: 0 },
    workflowtext: { type: [String, Array], default: () => [] },
    activitylogconfigcycle: { type: Object, default: () => ({}) },
    pagecount: { type: Number, default: 1 },
    page: { type: Number, default: 1 },
    showViewToggle: { type: Boolean, default: false },
    hideExtraControls: { type: Boolean, default: false },
    /** @type {Boolean} Whether to hide the actions button - used when actions icon is moved to parent component */
    hideActionsButton: { type: Boolean, default: false },
    isRevenueBreakupMode: { type: Boolean, default: false },
    /** @type {String} API base path - 'analysis' for RUDataSection, 'sl_analysis' for GLBreakdown */
    apiBasePath: { type: String, default: 'analysis' },
    slGroupedView: { type: Number, default: 0 }, // 0 = Grouped, 1 = Ungrouped (separate from toggletableview)
    /** @type {Boolean} Whether preparer has any items available for bulk local commentary submission */
    hasPreparerActionableItems: { type: Boolean, default: true },
    /** @type {String} Label for Reporting Unit (RU) - used in download buttons */
    ruLabel: { type: String, default: 'RU' },
    /** @type {Boolean} Whether to hide the role selector dropdown - used when role selector is in parent (e.g., Breadcrumbs) */
    hideRoleSelector: { type: Boolean, default: false },

    actualLabel: { type: String, default: 'Actual' },
    proformaLabel: { type: String, default: 'Proforma' },
    forecastLabel: { type: String, default: 'Forecast' },
  },
  data() {
    return {
      // All filter values for Select All functionality
      allFilterValues: [0, 1, -1, 5, 6, -2, 7, 4, 3, 9],
      // Actions menu open state
      actionsMenuOpen: false,
      // View options menu open state
      viewOptionsMenuOpen: false,
      // Filter menu open state
      filterMenuOpen: false,
      // Role selector menu open state
      roleSelectorMenuOpen: false,
    };
  },
  computed: {
    selectedFilterProxy: {
      get() {
        return this.selectedfilter || [];
      },
      set(value) {
        this.$emit('update:selected-filter', value);
      },
    },
    isAllSelected() {
      // Check if all filter values are selected
      return this.allFilterValues.every(val => (this.selectedfilter || []).includes(val));
    },
    hasRequestableItems() {
      if (!Array.isArray(this.multiselectdata) || this.multiselectdata.length === 0) {
        return false;
      }
      
      return this.multiselectdata.some(id => {
        const item = (this.commentarydata || []).find(el => el._id === id);
        return item && REQUEST_COMMENTARY_ELIGIBLE_STAGES.includes(item.__stage);
      });
    },
    shouldShowActivityLog() {
      const isStandardView = this.toggleview !== 3 && this.toggletableview !== 1 && !this.hideExtraControls;
      return (isStandardView || this.isRevenueBreakupMode) && this.apiBasePath !== 'sl_analysis';
    },
    isRuClosed() {
      const localClosed = this.commentarycycledata?.local_ru_approve === true;
      const regionalClosed = this.commentarycycledata?.regional_ru_approve === true;
      const localDisabled = this.workflows.islocalenabled !== true;
      const regionalDisabled = this.workflows.isregionalenabled !== true;
      
      return (
        (regionalClosed && localClosed) ||
        (regionalClosed && localDisabled) ||
        (localClosed && regionalDisabled)
      );
    },
    roleDisplayConfig() {
      const hasSingleRole = (this.ruRoleOptions || []).length <= 1;
      if (!(this.isSodEnabled || hasSingleRole)) {
        return null;
      }

      const getLabel = (key, fallback) => {
        return this.$nova?.labelsName?.('cycle_page', key, fallback) ?? fallback;
      };

      if (this.isregionalapprover || this.toggleview === 3) {
        return {
          label: getLabel('commentary_regional_approver_label', 'Regional Approver'),
          tone: 'success',
        };
      }

      if (this.ispreparer) {
        return {
          label: getLabel('commentary_local_preparer_label', 'Local Preparer'),
          tone: 'info',
        };
      }

      if (this.isapprover) {
        return {
          label: getLabel('commentary_local_approver_label', 'Local Approver'),
          tone: 'warning',
        };
      }

      if (this.ismanager) {
        return {
          label: 'Manager',
          tone: 'neutral',
        };
      }

      if (this.isviewonly) {
        return {
          label: 'View Only',
          tone: 'error',
        };
      }

      return null;
    },
    internalToggleTableView: {
      get() {
        return this.toggletableview;
      },
      set(value) {
        // Emit event to parent when value changes
        this.$emit('update:toggletableview', value);
      }
    },
    internalSlGroupedView: {
      get() {
        return this.slGroupedView;
      },
      set(value) {
        // Emit event to parent when value changes - separate from toggletableview
        this.$emit('update:sl-grouped-view', value);
      }
    },
    /**
     * Computed label for View Options chip
     * Shows the current selection combination (e.g., "List - vs Proforma", "Commentary - All")
     * Returns "View Options" when no specific combination is selected
     */
    viewOptionsLabel() {
      const viewType = this.isCommentaryView ? 'Commentary' : 'List';
      let readType = '';
      
      if (this.cycletypeReadview === 'All') {
        readType = 'All';
      } else if (this.cycletypeReadview === 'Proforma') {
        readType = `vs ${this.proformaLabel}`;
      } else if (this.cycletypeReadview === 'Forecast') {
        readType = `vs ${this.forecastLabel}`;
      }
      
      // If we have both view and read selections, show combined label
      if (readType) {
        return `${viewType} - ${readType}`;
      }
      
      // Default label
      return 'View Options';
    },
    roleSelectorLabel() {
      const selected = (this.ruRoleOptions || []).find(option => option.value === this.selectedRuRole);
      if (selected) {
        return selected.label;
      }
      const firstOption = (this.ruRoleOptions || [])[0];
      return firstOption ? firstOption.label : this.$nova?.labelsName?.('cycle_page', 'commentary_role_placeholder', 'Select Role') ?? 'Select Role';
    },
  },
  methods: {
    /**
     * Opens the filter menu programmatically
     * Can be called via ref from parent component
     */
    openFilterMenu() {
      this.filterMenuOpen = true;
    },
    /**
     * Opens the actions menu programmatically
     * Can be called via ref from parent component
     */
    openActionsMenu() {
      this.actionsMenuOpen = true;
    },
    /**
     * Handles menu action click - emits the event and closes the menu
     * @param {String} eventName - The event name to emit
     * @param {Array} args - Optional arguments to pass with the event
     */
    handleMenuAction(eventName, args = []) {
      this.$emit(eventName, ...args);
      this.actionsMenuOpen = false;
    },
    /**
     * Opens the Conversation dialog by triggering the lb-conversation component's internal method
     */
    openConversationDialog() {
      this.actionsMenuOpen = false;
      this.$nextTick(() => {
        if (this.$refs.conversationComponent) {
          this.$refs.conversationComponent.onConversationClick();
        }
      });
    },
    /**
     * Opens the Activity Log dialog by triggering the lb-activitylog component's internal method
     */
    openActivityLogDialog() {
      this.actionsMenuOpen = false;
      this.$nextTick(() => {
        if (this.$refs.activityLogComponent) {
          this.$refs.activityLogComponent.dialog = true;
          this.$refs.activityLogComponent.loadData();
        }
      });
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        // Unselect all
        this.$emit('update:selected-filter', []);
      } else {
        // Select all
        this.$emit('update:selected-filter', [...this.allFilterValues]);
      }
    },
    toggleFilterValue(value) {
      const currentFilters = [...(this.selectedfilter || [])];
      const index = currentFilters.indexOf(value);
      if (index > -1) {
        currentFilters.splice(index, 1);
      } else {
        currentFilters.push(value);
      }
      this.$emit('update:selected-filter', currentFilters);
    },
    isFilterSelected(value) {
      return (this.selectedfilter || []).includes(value);
    },
    /**
     * Handles view toggle between List and Commentary views
     * @param {Boolean} isCommentary - true for Commentary view, false for List view
     */
    handleViewToggle(isCommentary) {
      // v-radio-group emits the selected value directly
      if (isCommentary !== this.isCommentaryView) {
        this.$emit('toggle-view');
      }
    },
    /**
     * Handles read toggle between All, Proforma and Forecast
     * @param {String} value - 'All', 'Proforma' or 'Forecast'
     */
    handleReadToggle(value) {
      if (value !== this.cycletypeReadview) {
        this.$emit('update:cycletype-readview', value);
      }
    },
    /**
     * Handle selection of a role from the dropdown menu
     * @param {String|Number|null} value - Selected role value
     */
    handleRoleSelect(value) {
      if (value !== this.selectedRuRole) {
        this.$emit('update:selected-ru-role', value);
      }
      this.roleSelectorMenuOpen = false;
    },
    handleScroll() {
      if (this.viewOptionsMenuOpen) this.viewOptionsMenuOpen = false;
      if (this.roleSelectorMenuOpen) this.roleSelectorMenuOpen = false;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style scoped>
/* Role Chip Styles - Custom container with specified layout */
.role-chip {
  display: flex;
  align-items: center;
  width: 214px;
  height: 40px;
  gap: 8px;
  padding: 6px 8px; /* padding-top/right/bottom: xs (8px), padding-left: md (16px) */
  border-radius: 10px;
  border: 1px solid var(--Text-Grey-Weak, #B2B2B4);
  background: var(--background-gray-weak, #FFFFFF);
  opacity: 1;
}

.role-chip__content {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}

.role-chip__icon {
  color: var(--grey-500);
  flex-shrink: 0;
}

.role-chip__label {
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Role Selector Dropdown Styles */
.role-selector__wrapper {
  width: 214px;
}

.role-selector__activator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 214px;
  height: 40px;
  padding: 8px 12px 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--Text-Grey-Weak, #B2B2B4);
  background: var(--background-gray-weak, #FFFFFF);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.role-selector__activator:hover {
  border-color: var(--color-primary, #1976d2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.role-selector__chevron {
  color: var(--color-status-card-text, #828285);
}

.role-selector__menu {
  min-width: 214px;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08), 0 1px 4px 0 var(--opacity-200, rgba(5, 5, 6, 0.16)), 0 1px 4px 0 var(--opacity-100, rgba(5, 5, 6, 0.08));
  border: 1px solid var(--grey-300, #B2B2B4);
  padding: 12px;
}

.role-selector__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  color: var(--grey-500) !important;
  transition: background-color 0.2s ease;
  border-radius: var(--radius-sm, 8px);
}

.role-selector__item:hover {
  background: var(--grey-50, #F7F7F7);
  color: var(--grey-900, #2C2C35);
}

.role-selector__item--active {
  background: var(--grey-50, #F7F7F7);
  color: var(--grey-900, #2C2C35) !important;
}

.role-selector__check {
  color: var(--color-primary, #1976d2);
}

.custom-view-label >>> .v-label {
  font-size: 1rem;
}

/* Actions Menu Card Styles */
.actions-menu-card {
  min-width: 280px;
  max-width: 350px;
  overflow: hidden;
}

.actions-menu-card .v-card__title {
  font-size: 0.95rem;
}

.actions-menu-card .v-list {
  max-height: 400px;
  overflow-y: auto;
}

/* Actions Menu List Item Styles */
.actions-menu-card .v-list-item {
  transition: background-color 0.2s ease;
}

.actions-menu-card .v-list-item:hover {
  background-color: #f5f5f5;
}

.actions-menu-card .v-list-item__title {
  font-size: calc(var(--text-size-xs) + 2px) !important;
  color: #6d6d6d;
}

.actions-menu-card .v-list-item__title.text--disabled {
  color: #bdbdbd;
}

.actions-menu-card .v-list-item__icon .v-icon {
  color: #6d6d6d;
}

/* Hidden trigger components - hide the button but allow dialog to render */
.hidden-trigger-components {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  pointer-events: none;
}

.hidden-trigger-components .v-dialog__container {
  position: fixed !important;
  overflow: visible !important;
  pointer-events: auto;
}

/* Toggle Slider Styles */
.toggle-slider-container {
  position: relative;
  display: inline-flex;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  padding: 4px;
}

.toggle-slider-bg {
  display: none;
}

.toggle-slider-indicator {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background-color: var(--color-primary);
  border-radius: 6px;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.toggle-slider-indicator.slide-right {
  left: calc(50% + 0px);
}

.toggle-slider-buttons {
  display: flex;
  position: relative;
  z-index: 1;
}

.toggle-slider-btn {
  flex: 1;
  min-width: 100px;
  padding: 6px 16px;
  font-weight: 500;
  color: #64748b;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
  white-space: nowrap;
  text-align: center;
}

.toggle-slider-btn.active {
  color: #ffffff;
}

.toggle-slider-btn:hover:not(.active) {
  color: #334155;
}

/* View Options Dropdown Styles */
.view-options-chip {
  display: flex;
  align-items: center;
  height: 40px;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 10px;
  border: 1px solid var(--Text-Grey-Weak, #B2B2B4);
  background: var(--background-gray-weak, #FFFFFF);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.view-options-chip:hover {
  border-color: var(--color-primary, #1976d2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.view-options-chip__icon {
  color: var(--Text-Grey-Default, #2C2C35);
  margin-top: 2px;
  flex-shrink: 0;
}

.view-options-chip__label {
  color: var(--Text-Grey-Default, #2C2C35);
   
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}

.view-options-chip__chevron {
  color: var(--color-status-card-text, #828285);
  flex-shrink: 0;
  margin-left: auto;
}

.view-options-card {
  min-width: 200px;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 4px 4px 20px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid var(--Text-Grey-Weak, #B2B2B4);
}

.view-options-section__header {
  font-size: 14px;
  font-weight: 600;
  color: var(--grey-900, #2C2C35);
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.view-options-section__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.view-options-radio-group {
  margin: 0 !important;
}

.view-options-radio-group >>> .v-input--radio-group__input {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.view-options-radio {
  margin: 0 !important;
}

.view-options-radio >>> .v-input--selection-controls__input {
  margin-right: 8px;
}

.view-options-radio__label {
  font-size: 14px;
  font-weight: 400;
  color: var(--grey-500, #828285);
  line-height: 20px;
}

/* Custom View Box Styles */
.custom-view-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid var(--Text-Grey-Weak, #B2B2B4);
  background: var(--background-gray-weak, #FFFFFF);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.custom-view-box:hover {
  border-color: var(--color-primary, #1976d2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-view-box--active {
  border-color: var(--color-primary, #193541);
  border-width: 2px;
  background: var(--background-gray-weak, #F7F7F7);
}

.custom-view-box__icon {
  width: 20px;
  height: 20px;
  color: var(--color-status-card-text, #828285);
  transition: color 0.2s ease, filter 0.2s ease;
}

.custom-view-box__icon--active {
  color: var(--color-primary, #193541);
  filter: brightness(0) saturate(100%) invert(15%) sepia(10%) saturate(1500%) hue-rotate(160deg) brightness(95%) contrast(90%);
}

/* Comparison select dropdown styling */
.Comparion-select >>> .v-select__selection {
  font-size: 0.875rem;
}
</style>

<!-- Global styles for dropdown menu (rendered outside component) -->
<style>
.comparison-dropdown-menu .v-list-item__title {
  font-size: var(--font-size-xs) !important;
}
.filterBtn .v-btn__content {
  gap: 4px;
}
.border-off { border: 0 !important;}
.position-relative {
  position: relative !important;
}
</style>
